import AirdomeList from '../../../base/pages/airdomelist';
import columns from './Columns';

const airdomeList: AirdomeList = {
  columns,

  header: 'Air domes'
};

export default airdomeList;
